import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import tradedesk from './pictures/tradedesk.jpeg';
import attendees from './pictures/tradeDeskAttendees.jpeg';
import recruiter from './pictures/recruiterAtTradeDesk.jpeg';

const TradeDesk = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>WiC x Trade Desk: How to Ace Your Technical Interview!</h2>
                    <p class="site-post-meta">October 2, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>

                    Thank you to everyone who joined us for our recent event in collaboration with Trade Desk! We had a wonderful time connecting with Rachel at Trade Desk, learning more about Trade Desk, and grabbing lunch as well!

                    <br></br>
                    <br></br>


                    The highlight of the event was learning so much more about Trade Desk, their application and interview process. We also gained tips on how to prepare and succeed during this process!
                    
                    
                    <br></br>
                    <br></br>
                    
                    
                    We're so grateful to Rachel for speaking with us and offering such thoughtful advice. It was a great opportunity to ask one-on-one questions, gain special tips, and imagine what a future in tech could look like at Trade Desk. Thank you to everyone who joined!
                    
                    
                    </p>
                    <img src={tradedesk} alt="Attendees posing in front of slides for Trade Desk Event."/>
                    <img src={attendees} alt="Attendees listening at event."/>
                    <img src={recruiter} alt="Recruiter speaking at event."/>
                    
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default TradeDesk;
